module.exports = __webpack_public_path__ + "static/media/image-edit.b1b0ac55.svg";